import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDangerZone } from "./useDangerZone";

export const useUpdateDangerZone = () => {
  const queryClient = useQueryClient();
  const { updateDangerZone } = useDangerZone();

  return useMutation({
    mutationFn: updateDangerZone,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dangerzone"] });
    },
  });
};
